/* eslint-disable import/prefer-default-export */
import { cloneDeep, isEmpty } from 'lodash'
import { ServiceProperty } from 'schemas/ServicePropertySchema'
import ComparisonMode from 'enums/ComparisonMode'
import { SideBySideWidgetsType } from '../../types'

export const servicePropertySetter = (
  widgetSetting: SideBySideWidgetsType,
  serviceProperties: ServiceProperty
) => {
  const { pivotThemeInfos, colComparisonMode, tagNames, docNames } = widgetSetting
  const resultServiceProperties = cloneDeep(serviceProperties)

  const pivotThemeIds = pivotThemeInfos?.map((themeInfo) => themeInfo.themeId) ?? []

  resultServiceProperties.themeIds = pivotThemeIds
  resultServiceProperties.tagNames = tagNames
  resultServiceProperties.docNames = docNames

  resultServiceProperties.rowComparisonMode = ComparisonMode.TOPICS

  if (colComparisonMode === ComparisonMode.THEMES && !isEmpty(pivotThemeIds)) {
    resultServiceProperties.colComparisonMode = ComparisonMode.THEMES
  } else if (colComparisonMode === ComparisonMode.TAGS && !isEmpty(tagNames)) {
    resultServiceProperties.colComparisonMode = ComparisonMode.TAGS
  } else if (colComparisonMode === ComparisonMode.DOC_HIERARCHIES && !isEmpty(docNames)) {
    resultServiceProperties.colComparisonMode = ComparisonMode.DOC_HIERARCHIES
  } else {
    resultServiceProperties.colComparisonMode = ComparisonMode.NONE
  }

  return resultServiceProperties
}
